import { useEffect, useState } from 'react'

import { MOBILE_SHELL_MEDIA } from '@/config/layoutBreakpoints'

const MOBILE_PERF_MEDIA = MOBILE_SHELL_MEDIA

export function isMobilePerfViewport(): boolean {
  if (typeof window === 'undefined') return false
  return window.matchMedia(MOBILE_PERF_MEDIA).matches
}

/** Viewports where we prefer opaque surfaces over backdrop blur and heavy cosmic layers. */
export function useMobilePerfViewport(): boolean {
  const [mobile, setMobile] = useState(isMobilePerfViewport)

  useEffect(() => {
    const media = window.matchMedia(MOBILE_PERF_MEDIA)
    const onChange = () => setMobile(media.matches)
    onChange()
    media.addEventListener('change', onChange)
    return () => media.removeEventListener('change', onChange)
  }, [])

  return mobile
}
